import axios from "axios";
import { AI_AGENT_API_DOMAIN, API_DOMAIN, REACT_APP_HMAC_SECRET_KEY } from "constants/schemas";
import { getCookie } from "helpers/cookie";
import { formatError } from "helpers/error";
import { showNotification } from "helpers/notification";
import CryptoJS from "crypto-js";


const generateControlHash = (
  path: string,
  method: string,
  body: any = {},
  timestamp: number
) => {
  if (!REACT_APP_HMAC_SECRET_KEY) {
    throw new Error("REACT_APP_HMAC_SECRET_KEY is missing");
  }
  const bodyString = JSON.stringify(body);
  const payload = `${timestamp}|${method}|${path}|${bodyString}`;
  return CryptoJS.HmacSHA256(payload, REACT_APP_HMAC_SECRET_KEY).toString();
};

const createHttpClient = (baseURL?: string) => {
  const instance = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Cookie: `utm_source=${getCookie("utm_source")}`,
    },
    withCredentials: true,
  });

  // Add request interceptor to add control hash
  instance.interceptors.request.use(
    (config) => {
      const path = config.url || "";
      const method = config.method?.toUpperCase() || "GET";
      const body = config.data || {};
      const timestamp = new Date().getTime();
      const controlHash = generateControlHash(path, method, body, timestamp);

      // Đảm bảo config.headers tồn tại và merge thay vì ghi đè
      config.headers = {
        ...config.headers,
        "x-client-request-control": controlHash,
        "x-client-timestamp": timestamp.toString(),
      };

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Add response interceptor
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const errorMsg = formatError(error)?.message || "Something went wrong";
      showNotification(errorMsg);
      return Promise.reject(error);
    }
  );

  return instance;
};

const createHttpClientt = (baseURL?: string) => {
  const instance = axios.create({
    baseURL,
    responseType: "stream",
  });

  // Add interceptors
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const errorMsg = formatError(error)?.message || "Something went wrong";
      showNotification(errorMsg);
      return Promise.reject(error);
    }
  );

  return instance;
};

const http = createHttpClient(API_DOMAIN);

export const agentHttp = createHttpClientt(AI_AGENT_API_DOMAIN);

export default http;
